import { getSchedulerDataServicesRepair, getSchedulerDataServicesInstall, getSchedulerDataServicesMaintenance } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"

export function DrainsSewer (){
  let servicesStart =  [
  {
    id: "Clogged Drains",
    label: <>Clogged Drains</>,
    remType: "repair",
    data: [
      [
        {
          name: "CloggedDrains",
          question: "How many drains are clogged?",
          answers: [
            {
              id: "One",
              label: <>One</>,
              value: "One",
              jobType: "Drain Clog or Blockage",
              remType: "repair"
            },
            {
              id: "Several",
              label: <>Several</>,
              value: "Several",
              jobType: "Drain Clog or Blockage",
              remType: "repair"
            },
            {
              id: "Entire House",
              label: <>Entire House</>,
              value: "Entire House",
              jobType: "Drain Clog or Blockage",
              remType: "repair"
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Broken Drain Line",
    label: <>Broken Drain Line</>,
    remType: "repair",
    jobType: "Drain Line Breakage",
    data: [],
  },
  {
    id: "Sewer Main Line",
    label: <>Sewer Main Line</>,
    remType: "repair",
    data: [
      [
        {
          name: "SewerMainLine",
          question: "Sewer Main Line",
          answers: [
            {
              id: "Clear/Clean",
              label: <>Clear/Clean</>,
              value: "Clear/Clean",
              jobType: "Sewer Main",
              remType: "repair"
            },
            {
              id: "Repair Broken Line",
              label: <>Repair Broken Line</>,
              value: "Repair Broken Line",
              jobType: "Sewer Main",
              remType: "repair"
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Basement Drainage",
    label: <>Basement Drainage</>,
    remType: "repair",
    jobType: "Basement Drainage Channels",
    data: [],
  },
];

let response = []

  servicesStart.map((services) => {
    if (services.remType == "estimate") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesInstall)[0])
    } else if (services.remType == "repair") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesRepair)[0])
    } else if (services.remType == "maintenance") {
      let serviceArray = []
      serviceArray.push(services)
      response.push(filteredServicesComponents(serviceArray, getSchedulerDataServicesMaintenance)[0])
    }


  })
  return response
}